import React from "react";
import DeviceOverviewBase from "../DeviceOverview";

/**
 * Bayi (dealer) firma kullanıcıları için cihaz listesi kabuğu.
 * Ağır liste/kart mantığı paylaşılan `DeviceOverview` çekirdeğinde kalır;
 * bu kabuk yalnızca rol bağlamını (isDealer=true) sabitler ve bayi-özel
 * ayarlamalar için tek giriş noktası sağlar.
 */
export default function DealerDeviceOverview(props) {
  return <DeviceOverviewBase {...props} isDealer={true} />;
}
